"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ContainerSnapshot = function () {
  function ContainerSnapshot() {}
  ContainerSnapshot.of = function (bindings, middleware) {
    var snapshot = new ContainerSnapshot();
    snapshot.bindings = bindings;
    snapshot.middleware = middleware;
    return snapshot;
  };
  return ContainerSnapshot;
}();
exports.ContainerSnapshot = ContainerSnapshot;